"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.regexp.split");




















































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {var h = this.$createElement;return { tableData: [], // 列表数据
      organizationList: [], robotId: '', insId: '', addItem: false, newadd: false, modOrg: false, title: '', searchData: { name: '', insId: '', sn: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', name: '', image: '' }, rules: { image: [{ required: true, message: '请上传题图', trigger: 'blur' }], name: [{ required: true, message: '请输入地图名称', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'image', label: '图片', formatter: function formatter(columns, index, val) {return h("img", { "attrs": { "src": val, "height": '30px' } });}, isShow: true }, { prop: 'name', label: '名称', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }], defaultProps: { children: 'child', label: 'insName' } };}, mounted: function mounted() {var self = this;var orgId = self.$route.query.orgId;if (orgId) {self.searchData.insId = orgId;}self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/robot/map', {}, function (res) {self.tableData = res;});}, getOrganziationList: function getOrganziationList() {var self = this;self.getData('/api/institution/dropList/0', {}, function (res) {self.organizationList = res;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.sn = '';this.searchData.name = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;if (this.searchData.deliverTimeEnd) {var endTime = this.searchData.deliverTimeEnd;if (endTime.split(' ').length < 2) {endTime = endTime + ' 23:59:59';this.searchData.deliverTimeEnd = endTime;}}if (this.searchData.deliverTimeStart) {var startTime = this.searchData.deliverTimeStart;if (startTime.split(' ').length < 2) {startTime = startTime + ' 00:00:00';this.searchData.deliverTimeStart = startTime;}}this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    fnUploadRequest: function fnUploadRequest(option) {
      var path = 'temi/map';
      _aliOss.default.ossUploadFile(option, path);
    },
    onsuccess: function onsuccess(res) {
      var iconUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.image = iconUrl;
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addItem = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addMap'].resetFields();
      this.cleanData();
      this.addItem = false;
      this.addItem2 = false;
    },
    beforeRemove: function beforeRemove(file, fileList) {
      var fileName = file.name;
      var confirm = '确定移除' + fileName + '？';
      return this.$confirm(confirm);
    },
    handleOnRemove: function handleOnRemove(file, fileList) {
      this.addData.icon = '';
      this.$message('移除' + file.name + '成功');
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';
      var self = this;
      self.addItem = true;
      self.addData = {
        name: item.name,
        image: item.image,
        id: item.id };

    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addMap.validate(function (valid) {
        if (valid) {
          self.postData('/api/temi/robot/map', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/robot/map?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.onCencal();
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.cleanData();
      this.addItem = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        name: '',
        image: '' };

    },
    openOrgDialog: function openOrgDialog(robotId) {
      var self = this;
      self.robotId = robotId;
      self.getIns(robotId);
      self.getOrganziationList();
      self.modOrg = true;
    },
    closeOrgDialog: function closeOrgDialog() {
      this.modOrg = false;
      this.insId = '';
      this.robotId = '';
      this.$refs.orgTree.setCheckedKeys([]);
    },
    checkFn: function checkFn(node, data) {
      var currKey = node.id;
      this.$refs.orgTree.setCheckedKeys([currKey]);
      this.insId = currKey;
    },
    getIns: function getIns(robot) {
      var self = this;
      self.getData('api/temi/robot/ins/' + robot, {}, function (res) {
        console.log(res);
        if (res.robotInsInfo !== null) {
          self.insId = res.robotInsInfo.insId;
          if (self.insId !== '') {
            self.$refs.orgTree.setCheckedKeys([self.insId]);
          }
        }
      });
    },
    bandIns: function bandIns() {// 新增提交操作
      var self = this;
      var ins = {
        insId: self.insId,
        robotId: self.robotId };

      if (ins.insId === '' || ins.robotId === '') {
        self.$message({ message: '请选择组织', type: 'error' });
        return false;
      }
      self.postData('/api/temi/robot/ins/' + ins.robotId, ins, function (res) {
        self.$message({
          message: '添加成功!',
          type: 'success' });

        self.closeOrgDialog();
        self.searchData.page = 1;
        self.init();
      });
    } } };exports.default = _default;